/* storybook-check-ignore */
import { Box } from '@opendoor/bricks-next';
import dynamic from 'next/dynamic';

import { determinePropertyActionability } from 'components/marketplace/helpers/propertyActionability';

import { BuyWithConfidence } from '../BuyWithConfidence';
import { PropertyDetailsType } from '../types';

interface PropertyCTAsProps {
  property: PropertyDetailsType;
}

const BuyDirectCTA = dynamic(() => import('../BuyDirectCTA').then((mod) => mod.BuyDirectCTA), {
  ssr: false,
});

export const PropertyCTAs = ({ property }: PropertyCTAsProps) => {
  const { isActionable, tourKind, showBuyDirect } = determinePropertyActionability(property);

  if (!isActionable || !tourKind) {
    return null;
  }

  return (
    <Box tag="menu" px={0} mt="$24x" mb={0} gap="$24x">
      <BuyDirectCTA property={property} />
      {showBuyDirect && <BuyWithConfidence />}
    </Box>
  );
};
